export const navTranslations = {
  nl: {
    home: "Home",
    menu: "Menu",
    catering: "Catering",
    marketDay: "Marktdag",
    contact: "Contact",
    orderNow: "Bestel Nu",
  },
  en: {
    home: "Home",
    menu: "Menu",
    catering: "Catering",
    marketDay: "Market Day",
    contact: "Contact",
    orderNow: "Order Now",
  },
};